<template>
    <div style="height:100%;overflow:hidden;position: relative;overflow-y: auto;background: #eaeaea">
        <div class="top-field">
            <img src="../assets/img/query_bg.jpg" style="width: 100%"/>
        </div>
        <div class="relative-1">
            <!--<img style="width: 20px;margin-top: 20px;margin-left: 27px" src="../assets/img/return_trans.png" />-->
            <div class="title">病例信息</div>
            <div class="form-panel">
                <div v-html="chargeInfo"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast, MessageBox} from 'mint-ui';


    export default {
        name: "RegistSubscribe",
        data() {
            return {
                YY_USER_ID: "",
                form: {
                    name: "",
                    phone: ""
                },
                hasBind: false,
                bindNo: "",
                chargeInfo: "数据加载中..."
            }
        },
        methods: {
            submit: function () {
                var phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (!phoneReg.test(this.form.phone)) {
                    Toast("请填写正确的手机号码");
                    return;
                }
                Indicator.open('加载中...');
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=bd>xh>>" + this.form.phone + "w>>" + this.$route.query.openId;
                api.corsGet(url, (res) => {
                    if (res != "not find client") {
                        if (res == "成功绑定！") {
                            this.loadBindInfo();
                        } else {
                            Toast(res);
                        }
                    } else {
                        Toast("诊所信息错误");
                    }
                    Indicator.close();
                }, (err) => {
                    Indicator.close();
                    Toast("网络出错，请稍后再试");
                    console.log(err);
                })
            },
            loadBindInfo: function (callback) {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=is>" + this.$route.query.openId;
                Indicator.open('加载中...');

                api.corsGet(url, (res) => {
                    Indicator.close();
                    console.log(res);
                    if (res != "not find client") {
                        if (res == "") {
                            this.chargeInfo = "请先绑定患者用户";
                            MessageBox({
                                title: '提示',
                                message: '尚未绑定患者，请前往绑定?',
                                confirmButtonText: "前往绑定"
                            }).then(() => {
                                this.$router.push({
                                    path: "/bindPatient",
                                    query: {
                                        YY_USER_ID: this.$route.query.YY_USER_ID,
                                        openId: this.$route.query.openId
                                    }
                                })
                            }).catch(() => {
                                this.chargeInfo = "请先绑定患者用户"
                            });
                            ;
                        } else {
                            _this.hasBind = true;
                            _this.bindNo = res;
                            callback && callback();
                        }
                    }
                }, (err) => {
                    Toast("网络出错，请稍后再试");
                    Indicator.close();
                    console.log(err);
                })
            },
            loadChargeDetail: function () {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=e>>tel2t>>" + this.bindNo;
                api.corsGet(url, (res) => {
                    console.log(res);
                    _this.chargeInfo = res;
                }, (err) => {
                    Toast("网络出错，请稍后再试");
                    Indicator.close();
                    console.log(err);
                })
            }
        },
        created() {
            var _this = this;
            utils.doIF(() => {
                _this.form.name = this.$store.state.baseInfo.name;
                _this.loadBindInfo(() => {
                    _this.loadChargeDetail();
                });
            }, () => {
                return !!this.$store.state.baseInfo && this.$route.query.openId;
            });
        },
        mounted() {
            var _this = this;
            window._this = this;
        }
    }
</script>

<style scoped>
    .top-field {
        width: 100%;
        height: 0;
    }

    .title {
        color: white;
        font-size: 20px;
        padding: 27px;
        letter-spacing: 3px;
    }

    .title:after {
        content: "";
        display: block;
        width: 50px;
        height: 1px;
        background: white;
        margin-top: 15px;
    }

    .relative-1 {
        position: relative;
        z-index: 1;
    }

    .form-panel {
        margin: 40px 14px;
        background: white;
        border-radius: 7px;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.19);
        padding: 31px 38px;
        font-size: 16px;
        color: #666666;
        line-height: 30px;
    }

    .form-item {
        background: #f1f0f1;
        border-radius: 100px;
    }

    .form-item > input {
        background: none;
        border: none;
        outline: none;
        box-shadow: none;
        color: #333333;
    }

    .form-item:not(:first-child) {
        margin-top: 18px;
    }

    .form-button {
        padding: 9px 22px;
        background: #43baeb;
        color: white;
        border-radius: 100px;
        margin-top: 18px;
        text-align: center;
        font-size: 14px;
        letter-spacing: 2px;
    }

    .form-button:active {
        background: #33aacb;
    }

    .form-input {
        width: 100%;
        padding: 10px 22px;
        box-sizing: border-box;
    }

    input::-webkit-input-placeholder {
        color: #aaaaaa;
    }
</style>